import ConfirmationModal from '../../../components/confirmation-modal';
import PluginAction from '../../plugin-action';

/**
 * Action for the list of student registrations.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class StudentsListAction extends PluginAction {
    constructor(container: HTMLElement) {
        super(container);
        this.initializeForm();
        this.initializeModals();
        StudentsListAction.emitter.emit('ready', this);
    }

    /**
     * Initializes the search form, if some registrations are present.
     */
    private initializeForm(): void {
        const form = this.container.querySelector<HTMLFormElement>('form');
        if (!form) {
            return;
        }
        const sortByField = form.querySelector<HTMLInputElement>('[name="tx_sitepackage_studentscheckliststep[demand][sortBy]"]');
        if (!sortByField) {
            return;
        }

        // Initialize generic sending of the form via a data attribute
        form.querySelectorAll<HTMLElement>('[data-submit]').forEach(element => {
            const eventType = element.dataset.submit;
            if (!eventType) {
                return;
            }

            element.addEventListener(eventType, () => {
                // Apply custom sorting
                if (element.dataset.sortBy) {
                    // A custom sorting is active; invert sort direction, if the property stayed the same
                    let sortDirection = 'ASC';
                    if (sortByField.value !== '') {
                        const parts = sortByField.value.split(' ');
                        if (parts.length === 2 && parts[0] === element.dataset.sortBy) {
                            sortDirection = parts[1] === 'ASC' ? 'DESC' : 'ASC';
                        }
                    }
                    sortByField.value = element.dataset.sortBy + ' ' + sortDirection;
                }
                form.submit();
            });
        });
    }

    /**
     * Initializes all modals in this action.
     */
    private initializeModals(): void {
        // Initialize modal to remove a registration
        const removeModal = document.querySelector<HTMLElement>('#removeModal');
        if (removeModal) {
            const removeConfirmation = new ConfirmationModal(removeModal);
            removeConfirmation.emitter.on('confirm', (link: HTMLLinkElement) => {
                window.location.href = link.href;
            });

            this.container.querySelectorAll<HTMLLinkElement>('[data-action="remove"]').forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();
                    removeConfirmation.value = link;
                    removeConfirmation.show();
                });
            });
        }
    }
}
